import { render, staticRenderFns } from "./PlatformProtocol.vue?vue&type=template&id=cfe0aaf0&scoped=true&"
import script from "./PlatformProtocol.vue?vue&type=script&lang=js&"
export * from "./PlatformProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PlatformProtocol.vue?vue&type=style&index=0&id=cfe0aaf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe0aaf0",
  null
  
)

export default component.exports